"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateQrWalletImg = void 0;
const constants_1 = require("../../constants/constants");
const axiosConfig_1 = require("../axios/axiosConfig");
const storageUtils_1 = require("../utils/storageUtils");
const generateQrWalletImg = (body) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        body.user_id = (0, storageUtils_1.getItem)(constants_1.StorageKeys.user_id) || 0;
        let res = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.Routes.generateQrWalletImg(), Object.assign({}, body), { responseType: "blob", suppressNetworkError: true });
        const blob = res.data;
        const newBlob = new Blob([blob], { type: "image/png" });
        const blobUrl = window.URL.createObjectURL(newBlob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `${body.credentialName} QR.png`);
        link.setAttribute("target", `_blank`);
        document.body.appendChild(link);
        link.click();
        (_a = link.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(link);
        window.URL.revokeObjectURL(blob);
    }
    catch (err) {
        console.log(err);
        throw err;
    }
});
exports.generateQrWalletImg = generateQrWalletImg;
